import React from 'react';
import championShip2024Image from './campeonato_spanya_aire_libre_deportistas_discapacidad_2024.jpeg';

export const DownLoadPoster2024 = (): React.ReactElement => {

    return (
        <img        
            src={championShip2024Image}
            alt='Campeonato de españa al aire libre para deportistas con discapacidad'
        />
    )
}